// Export variable for GSAP

export let mediaText = document.querySelectorAll('.wp-block-media-text')
export let mediaColumns = document.querySelectorAll('.wp-block-columns.block-video')
export let blockColumns = document.querySelectorAll('.wp-block-columns')
export let blockCover = document.querySelectorAll('.wp-block-cover')
export let kBlocks = document.querySelectorAll('.kb-posts-cards')
export let trainings = document.querySelectorAll('.imie-trainings.trainings-cards')
